// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crumb[data-v-05777bf6]{display:flex;align-items:center;height:50px;line-height:50px;text-align:left;background-color:#fff;margin-bottom:10px;padding-left:20px;box-shadow:0 3px 3px 0 hsla(0,0%,82.7%,.27)}.crumb[data-v-05777bf6]  .el-breadcrumb{height:50px;line-height:50px;padding-left:5px}", ""]);
// Exports
module.exports = exports;
